const locale = {
    placeholder: '時間を選択',
    rangePlaceholder: ['開始時間', '終了時間'],
};
export default locale;
